export default "__VITE_ASSET__BIfBFxKs__"